<template>
  <div class="home-page">
    <div class="bgColor"></div>
    <div class="toTop" v-if="toTopShow" @click="toTop">
      <div class="toTop_btn">
        <img src="../assets/toTop.png" alt="">
      </div>
    </div>
    <div class="inner_container">
      <div class="bg01">
        <img src="../assets/BG01.png" alt="">
      </div>
      <div class="top-container">
        <div class="logo">
          <img src="../assets/IFLoop.png" alt="logo">
        </div>
        <div class="nav">
          <ul>
            <li v-for="(item, index) in navList" :key="index" :class="{ active: activeIndex === index }"
              @click="handleNavClick(index)">{{ $t(item) }}
            </li>
            <LanguageSwitcher @getLocale="handleLanguageChange" />
          </ul>
        </div>
      </div>
      <div class="title_tip">
        <div class="tip">
          <div class="tip1">{{ $t('txt.t1') }}</div>
          <div class="tip2">{{ $t('txt.t2') }}</div>
          <div class="water_box">
            <div style="display: flex;align-items: center;">
              <div class="water"></div>
              <div class="water3"></div>
            </div>
            <div style="display: flex;align-items: center;">
              <div class="water2"></div>
              <div style="display: flex;">
                <div class="water4"></div>
                <div class="water5"></div>
              </div>
            </div>
          </div>
          <div class="tip3">{{ '' }}</div>
        </div>
      </div>
      <div class="products">
        <div class="bg02">
          <img src="../assets/BG02.png" alt="">
        </div>
        <div class="products_tip">
          {{ $t('txt.t4') }}
        </div>
        
        <div class="prt_info">
          <div class="products_tip02">
            <div class="products_tip02_c">
              <div class="products_tip02_c_i" style="margin-bottom: 20px;">{{ $t('txt.t41') }}</div>
              <div class="products_tip02_c_i" style="margin-bottom: 20px;">{{ $t('txt.t5') }}</div>
              <div class="products_tip02_c_i" style="margin-bottom: 20px;">{{ $t('txt.t6') }}</div>
              <div class="products_tip02_c_i">{{ $t('txt.t7') }}</div>
            </div>
          </div>
        </div>
        <div class="bottom_tip">{{ $t('nav.Platforms') }}</div>
      </div>
      <div class="solutions">
        <div class="section_header">
          <div class="section_title">{{ $t('txt.pp_title') }}</div>
          <div class="section_intro">{{ $t('txt.pp_intro') }}</div>
        </div>
        <div class="solutions_grid">
          <div class="solution_card">
            <div class="solution_title">🧠 {{ $t('txt.t13') }}</div>
            <div class="solution_desc">{{ $t('txt.ai.desc') }}</div>
            <div class="solution_features_label">{{ $t('txt.core_features') }}</div>
            <ul class="solution_features">
              <li>🤖 {{ $t('txt.ai.f1') }}</li>
              <li>📊 {{ $t('txt.ai.f2') }}</li>
              <li>💬 {{ $t('txt.ai.f3') }}</li>
            </ul>
          </div>
          <div class="solution_card">
            <div class="solution_title">📄 {{ $t('txt.t14') }}</div>
            <div class="solution_desc">{{ $t('txt.idp.desc') }}</div>
            <div class="solution_features_label">{{ $t('txt.core_features') }}</div>
            <ul class="solution_features">
              <li>{{ $t('txt.idp.f1') }}</li>
              <li>{{ $t('txt.idp.f2') }}</li>
              <li>{{ $t('txt.idp.f3') }}</li>
            </ul>
          </div>
          <div class="solution_card">
            <div class="solution_title">🔗 {{ $t('txt.t15') }}</div>
            <div class="solution_desc">{{ $t('txt.scc.desc') }}</div>
            <div class="solution_features_label">{{ $t('txt.core_features') }}</div>
            <ul class="solution_features">
              <li>{{ $t('txt.scc.f1') }}</li>
              <li>{{ $t('txt.scc.f2') }}</li>
              <li>{{ $t('txt.scc.f3') }}</li>
            </ul>
          </div>
          <div class="solution_card">
            <div class="solution_title">🏭 {{ $t('txt.t16') }}</div>
            <div class="solution_desc">{{ $t('txt.ims.desc') }}</div>
            <div class="solution_features_label">{{ $t('txt.core_features') }}</div>
            <ul class="solution_features">
              <li>{{ $t('txt.ims.f1') }}</li>
              <li>{{ $t('txt.ims.f2') }}</li>
              <li>{{ $t('txt.ims.f3') }}</li>
            </ul>
          </div>
        </div>
        <div class="bottom_tip">{{ $t('nav.Services') }}</div>
      </div>
      <div class="services">
        <div class="ser_bg">
          <div class="ser_container">
            <!-- <div class="ser_tip">
              <div>{{ $t('txt.t11') }}</div>
              <div>{{ $t('txt.t12') }}</div>
            </div> -->
            <div class="ser_list_box">
              <div class="list_item">
                <div class="list_item_title">
                  <div>{{ $t('txt.t17') }}</div>
                </div>
                <div class="list_item_content">
                  <div style="margin-bottom: 20px;">{{ $t('txt.t18') }}</div>
                  <div>{{ $t('txt.t19') }}</div>
                </div>
              </div>
              <div class="list_item">
                <div class="list_item_title">
                  <div>{{ $t('txt.t20') }}</div>
                </div>
                <div class="list_item_content">
                  <div style="margin-bottom: 20px;">{{ $t('txt.t21') }}</div>
                  <div>{{ $t('txt.t22') }}</div>
                </div>
              </div>
              <div class="list_item">
                <div class="list_item_title">
                  <div>{{ $t('txt.t23') }}</div>
                </div>
                <div class="list_item_content">
                  <div style="margin-bottom: 20px;">{{ $t('txt.t24') }}</div>
                  <div>{{ $t('txt.t25') }}</div>
                </div>
              </div>
              <div class="list_item">
                <div class="list_item_title">
                  <div>{{ $t('txt.t26') }}</div>
                </div>
                <div class="list_item_content">
                  <div style="margin-bottom: 20px;">{{ $t('txt.t27') }}</div>
                  <div>{{ $t('txt.t28') }}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="ser_bottom_tip">{{ $t('nav.Cases') }}</div>

      </div>
    </div>
    <!-- 底部容器 -->
    <div class="bottom_container">
      <div class="partner_list_container">
        <div class="partner_list" v-if="partnerLogosLoop.length">
          <div class="partner_track" :style="{ animationDuration: partnerAnimationDuration }">
            <div
              v-for="(logo, index) in partnerLogosLoop"
              :key="`${logo.src}-${index}`"
              class="partner_list_item"
            >
              <img :src="logo.src" :alt="logo.alt">
            </div>
          </div>
        </div>
        <div class="partner_tip">{{ '' }}</div>
      </div>
      <div class="floot_info">
        <div class="floot_border_bottom">
          <div class="logo">
            <img src="../assets/IFLoop.png" alt="logo">
          </div>
          <div class="about_us">
            <div class="about_us_title">{{ $t('txt.t29') }}</div>
            <p class="about_us_desc">
              {{ $t('txt.t30') }}
            </p>
          </div>
        </div>

      </div>
      <div class="recorded_info">
        <div @click="toBeian">{{ '浙公网安备33018502002237号' }}</div>
        <div @click="toBeian2">{{ '浙ICP备2020039517号-1' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitcher from '../components/LanguageSwitcher.vue'

const partnerLogoContext = require.context('../assets', false, /_logo\.png$/)
const PARTNER_LOGOS = partnerLogoContext.keys().map((key) => {
  const filename = key.replace('./', '')
  return {
    src: partnerLogoContext(key),
    alt: filename.replace(/\.png$/i, '')
  }
})
export default {
  name: 'HomePage',
  components: { LanguageSwitcher },
  data() {
    return {
      navList: ['nav.home', 'nav.Platforms', 'nav.Services', 'nav.Cases', 'nav.About'],
      activeIndex: 0,
      local: localStorage.getItem('locale'),
      toTopShow: false,
      partnerLogos: PARTNER_LOGOS
    }
  },
  computed: {
    partnerLogosLoop() {
      if (!this.partnerLogos.length) return []
      return [...this.partnerLogos, ...this.partnerLogos]
    },
    partnerAnimationDuration() {
      const count = Math.max(this.partnerLogos.length, 1)
      return `${count * 4}s`
    },
    
  },
  mounted() {
    this.tt()
    
  },
  methods: {
    handleNavClick(index) {
      this.activeIndex = index
      if (this.activeIndex == 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      if (this.activeIndex == 1) {
        window.scrollTo({
          top: 1800,
          behavior: 'smooth'
        });
      }
      if (this.activeIndex == 2) {
        window.scrollTo({
          top: 2850,
          behavior: 'smooth'
        });
      }
      if (this.activeIndex == 3 || this.activeIndex == 4) {
        window.scrollTo({
          top: 3700,
          behavior: 'smooth'
        });
      }
      
    },
    handleLanguageChange(locale) {
      this.local = locale
    },
    toTop() {
      this.activeIndex = 0
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    tt() {
      window.addEventListener('scroll', () => {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition > 800) {
          this.toTopShow = true;
        }
        if (scrollPosition < 800) {
          this.toTopShow = false;
        }
      });
    },
    toBeian(){
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33018502002237')
    },
    toBeian2(){
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style lang="less" scoped>
.home-page {
  position: relative;
  width: 100%;
  height: 100%;
  background: #141415;

  .bgColor {
    position: fixed;
    width: 100%;
    height: 580px;
    bottom: 0px;
    left: 0px;
    // border-radius: 36% 64% 0% 100% / 100% 20% 80% 0%  ;
    background-image: radial-gradient(ellipse farthest-corner at bottom, rgba(189, 139, 255, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
    filter: blur(20px);
    // z-index: 9;
  }

  .toTop {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 100px;
    right: 40px;
    background: #ccc;
    border-radius: 50%;
    z-index: 30;

    img {
      width: 50%;
      height: 50%;
      margin-top: 18px;
    }
  }


  // 内层容器
  .inner_container {
    position: relative;
    padding: 45px 40px;

    .bg01 {
      position: absolute;
      top: 0;
      left: 0px;
      z-index: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .top-container {
      position: relative;
      // 顶部容器
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 10;

      // 顶部logo
      .logo {
        width: 100px;
        height: 30px;
      }

      // 顶部导航
      .nav {
        width: 40%;

        ul {
          display: flex;
          justify-content: space-between;
          align-items: center;

          // 顶部导航列表
          li {
            list-style: none;
            color: #ccc;
          }

          li.active {
            color: #ffffff;
            font-weight: bold;
          }

          li:hover {
            color: #ffffff;
            font-weight: bold;
            cursor: pointer;
          }
        }
      }
    }

    .title_tip {
      width: 100%;
      margin: 0 auto;
      padding-top: 250px;
      color: #fff;
      letter-spacing: 1px;

      /* 增加每个字符之间的空间 */
      .tip {
        position: relative;

        .tip1 {
          color: #ccc;
          font-size: 40px;
          font-weight: 100;

        }

        .tip2 {
          font-size: 64px;
          font-weight: 400;
          margin-top: 74px;
          letter-spacing: 4px;
        }

        .water_box {
          position: absolute;
          top: -30px;
          left: 50%;
          margin-left: -200px;
        }

        .tip3 {
          font-size: 30px;
          font-weight: 100;
          margin-top: 426px;
        }
      }

    }

    .products {
      position: relative;
      height: 900px;

      .bg02 {
        position: absolute;
        width: 800px;
        height: 800px;
        top: 0;
        left: 0;
        z-index: 10;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .products_tip {
        position: absolute;
        top: 150px;
        left: 170px;
        font-size: 40px;
        font-weight: 100;
        color: #fff;
        letter-spacing: 3px;
        z-index: 12;
      }

      .products_tip02 {
        position: absolute;
        top: 170px;
        left: 60px;
        font-size: 18px;
        font-weight: 100;
        color: #fff;
        letter-spacing: 3px;
        z-index: 12;
        text-align: left;
        line-height: 40px;
      }
     

      .prt_info {
        position: absolute;
        width: 70%;
        height: 567px;
        border-radius: 20px;
        top: 100px;
        right: 0;
        z-index: 11;
        background-image: linear-gradient(to right, rgba(189, 139, 255, 0.3) 0%, rgba(82, 71, 156, 0.8) 100%);
        backdrop-filter: blur(10px);

      }

      .bottom_tip {
        position: absolute;
        width: 100%;
        bottom: 0px;
        left: 0px;
        font-size: 30px;
        font-weight: 100;
        color: #fff;
        text-align: center;

      }
    }

    .solutions {
      position: relative;
      color: #fff;
      text-align: left;
      letter-spacing: 1px;
      padding: 114px 0px;

      .section_header {
        margin-bottom: 30px;

        .section_title {
          font-size: 40px;
          font-weight: 100;
          line-height: 48px;
          margin-bottom: 14px;
        }

        .section_intro {
          font-size: 16px;
          font-weight: 100;
          line-height: 28px;
          color: #d9d9d9;
          max-width: 1000px;
        }
      }

      .solutions_grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 30px 30px;
        margin-top: 30px;
      }

      .solution_card {
        border-radius: 20px;
        background-image: linear-gradient(200deg, rgba(189, 139, 255, 0) 0%, rgba(189, 139, 255, 0.6) 38%, rgba(189, 139, 255, 1) 100%);
        padding: 32px;
        min-height: 260px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
      }

      .solution_title {
        font-size: 22px;
        font-weight: 100;
        margin-bottom: 10px;
      }

      .solution_desc {
        font-size: 16px;
        font-weight: 100;
        color: #f0f0f0;
        line-height: 26px;
      }

      .solution_features_label {
        margin-top: 14px;
        font-size: 14px;
        color: #e6e6e6;
        opacity: 0.9;
      }

      .solution_features {
        margin: 10px 0 0 16px;
        padding: 0;
        font-size: 14px;
        line-height: 24px;
        color: #fff;
      }

      .bottom_tip {
        position: absolute;
        width: 100%;
        bottom: 0px;
        left: 0px;
        font-size: 30px;
        font-weight: 100;
        color: #fff;
        text-align: center;

      }
    }

    .services {
      position: relative;
      width: 100%;
      height: 930px;
      margin-top: 60px;

      .ser_bg {
        position: relative;
        width: 100%;
        height: 567px;
        background-image: linear-gradient(30deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);
        backdrop-filter: blur(10px);
        border-radius: 20px;

        .ser_container {
          position: absolute;
          width: 96%;
          top: 80px;
          left: 80px;

          .ser_tip {
            text-align: left;
            color: #fff;
            line-height: 30px;
          }

          .ser_list_box {
            display: flex;
            width: 100%;
            margin-top: 20px;

            .list_item {
              flex: 1;
              height: 472px;
              border-radius: 20px;
              background-image: linear-gradient(200deg, rgba(189, 139, 255, 0) 0%, rgba(189, 139, 255, 0.6) 38%, rgba(189, 139, 255, 1) 100%);
              margin-right: 90px;
              padding: 80px 40px;
              color: #fff;
              text-align: left;
              .list_item_title {
                font-size: 24px;
                font-weight: 100;
                color: #fff;
                margin-bottom: 40px;
              }
              .list_item_content {
                font-size: 16px;
                font-weight: 100;
                color: #fff;
              }
            }
          }
        }
      }

      .ser_bottom_tip {
        position: absolute;
        width: 100%;
        bottom: 50px;
        left: 0px;
        text-align: center;
        font-size: 30px;
        font-weight: 100;
        color: #fff;
      }

    }
  }

  // 底部信息
  .bottom_container {
    position: absolute;
    bottom: -686px;
    left: 0px;
    width: 100%;
    height: 752px;
    background: #000;
    z-index: 20;
    border-radius: 60px 60px 0px 0px;

    .partner_list_container {
      padding: 0 40px;
      .partner_list {
        position: relative;
        overflow: hidden;
        margin: 40px auto;
        padding: 10px 0;

        .partner_track {
          display: flex;
          align-items: center;
          gap: 50px;
          width: max-content;
          animation-name: partner-scroll;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }

        .partner_list_item {
          flex: 0 0 auto;
          width: 120px;
          height: 120px;
          border-radius: 20px;
          background: #fff;
          // background-image: linear-gradient(200deg, rgba(189, 139, 255, 0) 0%, rgba(189, 139, 255, 0.6) 38%, rgba(189, 139, 255, 1) 100%);
          // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
        }

        .partner_list_item img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          // filter: grayscale(1);
          transition: filter 0.3s ease;
        }

        .partner_list_item:hover img {
          filter: grayscale(0);
        }
      }

      .partner_tip {
        color: #fff;
      }
    }

    .floot_info {
      color: #fff;
      padding: 0px 40px;
      margin-top: 200px;

      .floot_border_bottom {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border-bottom: 1px solid #D9D9D9;
        padding-bottom: 40px;

        .info_ul {
          display: flex;
          justify-content: space-between;

          .ul_info {
            display: flex;
            flex-direction: column;
            margin-right: 80px;

            ul {
              padding: 0px;

              li {
                list-style: none;
                color: #ccc;
                margin-bottom: 20px;
              }

            }
          }

          .ul_info:last-child {
            margin-right: 0px;
          }
        }

        .about_us {
          flex: 1;
          margin-left: 60px;
          max-width: 800px;
          text-align: left;

          .about_us_title {
            font-size: 22px;
            font-weight: 600;
            color: #fff;
            margin-bottom: 16px;
          }

          .about_us_desc {
            font-size: 16px;
            line-height: 28px;
            color: #d9d9d9;
          }
        }
      }

    }

    .recorded_info {
      display: flex;
      justify-content: space-between;
      padding: 8px 40px;
      color: #d9d9d9;

      div {
        cursor: pointer;
        transition: color 0.2s ease;
      }

      div:hover {
        color: #47cdfb;
      }
    }
  }
}

@keyframes partner-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.water {
  width: 116px;
  height: 116px;

  transform: scale(1.1) perspective(800px);
  /* 放大并应用透视 */
  filter: brightness(1.2) contrast(1.1);
  /* 增加亮度和对比度 */
  border-radius: 50%;
  box-shadow: inset 10px 20px 30px rgb(0, 0, 0, 0.5),
    10px 10px 20px rgb(0, 0, 0, 0.3),
    15px 15px 30px rgb(0, 0, 0, 0.05),
    inset -10px -10px 15px rgb(255, 255, 255, 0.8);
}

.water2 {
  margin-top: 26px;
  width: 116px;
  height: 240px;

  transform: scale(1.1) perspective(800px);
  /* 放大并应用透视 */
  filter: brightness(1.2) contrast(1.1);
  /* 增加亮度和对比度 */
  border-radius: 50px;
  box-shadow: inset 10px 20px 30px rgb(0, 0, 0, 0.5),
    10px 10px 20px rgb(0, 0, 0, 0.3),
    15px 15px 30px rgb(0, 0, 0, 0.05),
    inset -10px -10px 15px rgb(255, 255, 255, 0.8);
}

.water3 {
  margin-left: 26px;
  width: 240px;
  height: 116px;

  transform: scale(1.1) perspective(800px);
  /* 放大并应用透视 */
  filter: brightness(1.2) contrast(1.1);
  /* 增加亮度和对比度 */
  border-radius: 50px;
  box-shadow: inset 10px 20px 30px rgb(0, 0, 0, 0.5),
    10px 10px 20px rgb(0, 0, 0, 0.3),
    15px 15px 30px rgb(0, 0, 0, 0.05),
    inset -10px -10px 15px rgb(255, 255, 255, 0.8);
}

.water4 {
  margin-top: 26px;
  margin-left: 26px;
  width: 116px;
  height: 240px;

  transform: scale(1.1) perspective(800px);
  /* 放大并应用透视 */
  filter: brightness(1.2) contrast(1.1);
  /* 增加亮度和对比度 */
  border-radius: 50px;
  box-shadow: inset 10px 20px 30px rgb(0, 0, 0, 0.5),
    10px 10px 20px rgb(0, 0, 0, 0.3),
    15px 15px 30px rgb(0, 0, 0, 0.05),
    inset -10px -10px 15px rgb(255, 255, 255, 0.8);
}

.water5 {
  margin-top: 26px;
  margin-left: 26px;
  width: 116px;
  height: 116px;

  transform: scale(1.1) perspective(800px);
  /* 放大并应用透视 */
  filter: brightness(1.2) contrast(1.1);
  /* 增加亮度和对比度 */
  border-radius: 50%;
  box-shadow: inset 10px 20px 30px rgb(0, 0, 0, 0.5),
    10px 10px 20px rgb(0, 0, 0, 0.3),
    15px 15px 30px rgb(0, 0, 0, 0.05),
    inset -10px -10px 15px rgb(255, 255, 255, 0.8);
}
</style>
